/* eslint-disable */
/**
 * @fileoverview gRPC-Web generated client stub for LocationTracking
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.24.4
// source: location_tracking.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.LocationTracking = require('./location_tracking_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.LocationTracking.LocationTrackingClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.LocationTracking.LocationTrackingPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.LocationTracking.LiveTrackingRequest,
 *   !proto.LocationTracking.TrackingResponse>}
 */
const methodDescriptor_LocationTracking_LiveTracking = new grpc.web.MethodDescriptor(
  '/LocationTracking.LocationTracking/LiveTracking',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.LocationTracking.LiveTrackingRequest,
  proto.LocationTracking.TrackingResponse,
  /**
   * @param {!proto.LocationTracking.LiveTrackingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.LocationTracking.TrackingResponse.deserializeBinary
);


/**
 * @param {!proto.LocationTracking.LiveTrackingRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.LocationTracking.TrackingResponse>}
 *     The XHR Node Readable Stream
 */
proto.LocationTracking.LocationTrackingClient.prototype.liveTracking =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/LocationTracking.LocationTracking/LiveTracking',
      request,
      metadata || {},
      methodDescriptor_LocationTracking_LiveTracking);
};


/**
 * @param {!proto.LocationTracking.LiveTrackingRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.LocationTracking.TrackingResponse>}
 *     The XHR Node Readable Stream
 */
proto.LocationTracking.LocationTrackingPromiseClient.prototype.liveTracking =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/LocationTracking.LocationTracking/LiveTracking',
      request,
      metadata || {},
      methodDescriptor_LocationTracking_LiveTracking);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.LocationTracking.Status,
 *   !proto.LocationTracking.StatusResponse>}
 */
const methodDescriptor_LocationTracking_StatusTracking = new grpc.web.MethodDescriptor(
  '/LocationTracking.LocationTracking/StatusTracking',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.LocationTracking.Status,
  proto.LocationTracking.StatusResponse,
  /**
   * @param {!proto.LocationTracking.Status} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.LocationTracking.StatusResponse.deserializeBinary
);


/**
 * @param {!proto.LocationTracking.Status} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.LocationTracking.StatusResponse>}
 *     The XHR Node Readable Stream
 */
proto.LocationTracking.LocationTrackingClient.prototype.statusTracking =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/LocationTracking.LocationTracking/StatusTracking',
      request,
      metadata || {},
      methodDescriptor_LocationTracking_StatusTracking);
};


/**
 * @param {!proto.LocationTracking.Status} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.LocationTracking.StatusResponse>}
 *     The XHR Node Readable Stream
 */
proto.LocationTracking.LocationTrackingPromiseClient.prototype.statusTracking =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/LocationTracking.LocationTracking/StatusTracking',
      request,
      metadata || {},
      methodDescriptor_LocationTracking_StatusTracking);
};


module.exports = proto.LocationTracking;

